import { useEffect, useState } from 'react';
import { getUploadSettings, updateUploadSettings } from '../../api/adminApi';

const DEFAULTS = { resource_max_mb: 50, presentation_max_mb: 10, video_max_mb: 500, assignment_max_mb: 20 };

const FIELDS = [
  {
    key:   'resource_max_mb',
    label: 'Resources max size',
    hint:  'PDF, DOCX, XLSX, CSV, ZIP',
    max:   500,
  },
  {
    key:   'presentation_max_mb',
    label: 'Slides max size',
    hint:  'PDF, PPTX, PPT',
    max:   500,
  },
  {
    key:   'video_max_mb',
    label: 'Video max size',
    hint:  'MP4, MOV, WEBM, AVI',
    max:   2048,
  },
  {
    key:   'assignment_max_mb',
    label: 'Assignment submissions max size',
    hint:  'PDF, DOCX, XLSX, ZIP, etc.',
    max:   500,
  },
];

export default function AdminSettings() {
  const [form,    setForm]    = useState(DEFAULTS);
  const [saving,  setSaving]  = useState(false);
  const [saved,   setSaved]   = useState(false);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState('');

  useEffect(() => {
    getUploadSettings()
      .then(s => setForm(f => ({ ...f, ...s })))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true); setError('');
    try {
      const payload = {};
      FIELDS.forEach(({ key, max }) => {
        const val = Number(form[key]);
        if (val >= 1 && val <= max) payload[key] = val;
      });
      const s = await updateUploadSettings(payload);
      setForm(f => ({ ...f, ...s }));
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (err) {
      setError(err.message || 'Failed to save');
    } finally {
      setSaving(false);
    }
  }

  return (
    <>
      <div className="ph">
        <div>
          <div className="bc">Admin / Settings</div>
          <div className="pt">Platform Settings</div>
          <div className="ps">Configure global limits and behaviour</div>
        </div>
      </div>

      <div className="body">
        <div className="card">
          <div className="ct">
            <span>⚙️ Upload Size Limits</span>
          </div>

          {loading ? (
            <div style={{ color: 'var(--muted)', fontSize: 13, padding: '16px 0' }}>Loading…</div>
          ) : (
            <form onSubmit={handleSave}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 18, marginBottom: 20 }}>
                {FIELDS.map(({ key, label, hint, max }) => (
                  <div key={key}>
                    <label style={{ display: 'block', fontSize: 12.5, fontWeight: 600, color: 'var(--ink)', marginBottom: 6 }}>
                      {label}
                    </label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <input
                        type="number"
                        min="1"
                        max={max}
                        className="li"
                        style={{ width: 90, margin: 0 }}
                        value={form[key] ?? ''}
                        onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                        required
                      />
                      <span style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.4 }}>
                        MB<br />
                        <span style={{ fontFamily: "'DM Mono',monospace", fontSize: 10 }}>{hint}</span>
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              {error && (
                <div style={{ marginBottom: 12, padding: '8px 12px', background: '#fff1f0', border: '1px solid #ffccc7', borderRadius: 'var(--rs)', fontSize: 12.5, color: '#cf1322' }}>
                  {error}
                </div>
              )}

              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <button className="btn btn-p btn-sm" type="submit" disabled={saving}>
                  {saving ? 'Saving…' : 'Save Limits'}
                </button>
                {saved && <span style={{ fontSize: 12.5, color: 'var(--green)' }}>✓ Saved</span>}
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
